// extracted by mini-css-extract-plugin
module.exports = {"item":"CertificateItem_item__pO7OF","provider":"CertificateItem_provider__3FEdB","time":"CertificateItem_time__1PGUA","title":"CertificateItem_title__iR_8Y"};